import { useSelector } from "react-redux";

export const useIsMenuCollapsed = () => {
	return useSelector((state: any) => state?.sidebar?.sidebarcollapse);
};
